import {ListFilterButton} from '@github-ui/list-filter-button'
import {createActionBarButtonAnchor} from '@github-ui/list-view/ActionBarButtonAnchor'

export type QuickFilterProps = {
  owner: string
  query: string
  repo: string
  onQueryChange: (query: string, filter: RepoPullsQuickFilterKind) => void
}

export type RepoPullsQuickFilterKind = 'assignee' | 'author' | 'label' | 'milestone' | 'projects' | 'reviews'

export function createQuickFilterAnchor(label: string) {
  // Register directly with ActionBar while preserving popup ref handling.
  // Fallback popup attributes apply until the picker supplies its state.
  const buttonProps = {
    as: ListFilterButton,
    children: label,
    'aria-label': `Filter by ${label.toLowerCase()}`,
    'aria-expanded': false,
    'aria-haspopup': 'dialog' as const,
    isActionBarItem: true,
  }

  return createActionBarButtonAnchor(buttonProps)
}
